import { History, Location, LocationState } from "history";
import { match, useHistory, useLocation, useRouteMatch } from "react-router-dom";

export type RouteComponentProps<
	// eslint-disable-next-line @typescript-eslint/no-empty-object-type
	Params extends { [K in keyof Params]?: string } = {},
	S = LocationState
> = {
	history: History<S>;
	location: Location<S>;
	match: match<Params>;
};

/**
 * This higher order component was removed from newer versions of React Router (in favor of hooks).
 * This is a simple re-implementation that injects the routing props
 * We can use it until we fully migrate to hooks in all components.
 * @deprecated please use hooks instead of withRouter, this is mostly for backwards compatibility
 */
export function withRouter<Props extends RouteComponentProps>(
	Component: React.ComponentType<Props>
) {
	return function Wrapper(props: Omit<Props, keyof RouteComponentProps>) {
		const location = useLocation();
		const history = useHistory();
		const routeMatch = useRouteMatch();

		return (
			<Component {...(props as Props)} location={location} history={history} match={routeMatch} />
		);
	};
}
